// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
  width: 200px;
  margin-top: 20px;
  margin-left: 10px;
  padding-bottom: 5px;
}

.warn {
  width: 200px;
  margin-left: 10px;
  padding-top: 0px;
  margin-bottom: 10px;
  font-size: 11px;
  color: #e30526;
}

.button {
  margin-left: 20px;
  margin-top: 10px;
  width: 175px;
  text-align: center;
}

.mat-icon {
  margin-bottom: 5px;
}

.label {
  margin-top: 20px;
  margin-left: 10px;
  font-weight: bold;
  font-size: 17px;
}

.table {
  margin-top: 10px;
  width: 100%;
}

.table-header {
  font-weight: bold;
  background-color: #f2f2ef;
  color: #3b3b39;
  font-size: 15pt;
  text-align: center;
  width: 100%;
  margin-top: 2px;
  margin-bottom: 2px;
  padding-bottom: 7px;
  padding-top: 5px;
}

.segment {
  font-weight: bold;
  background-color: #7b7b7b;
  color: #ffffff;
  margin-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;
  padding-top: 3px;
}

.region {
  font-weight: bold;
  margin-top: 3px;
  padding-left: 15px;
  border-bottom: 1px solid black;
  padding-bottom: 4px;
}

.menu-relative {
  display: flex;
}

.table-relative {
  width: 100%;
  height: 84vh;
}

.header-style {
  font-weight: bold;
  font-size: 15px;
  width: 40px;
  text-align: center;
  padding-left: 5px !important;
}

.mat-mdc-cell {
  width: 10px;
  word-break: break-all;
  border-right: 1px solid #d7d7d7;
  padding-left: 5px !important;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 13px;
  text-align: center;
}

tr.mat-mdc-header-row {
  height: 20px !important;
  padding-top: 3px !important;
}

tr.mat-mdc-row {
  height: 28px;
}

.table-div {
  width: 100%;
  padding-bottom: 20px;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.check-mark {
  padding-left: 7px;
}

.message {
  background-color: yellow;
  border: 1px solid black;
  padding: 3px;
  margin-bottom: 9px;
  border-radius: 5px;
  font-weight: bold;
}

.cvRouter {
  bottom: 0px;
  position: static;
  width: 100% !important;
  margin: 0px;
  padding: 0px;
}

:host ::ng-deep .p-multiselect-panel {
  width: 200px;
}

:host ::ng-deep .p-select {
  width: 200px;
}

:host ::ng-deep .p-datatable-header {
  background-color: #f2f2ef;
  font-size: 25px;
  text-align: center;
}

.help-msg {
  font-size: 12px;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/reports/competitor-vehicle/competitor-vehicle.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AACF;;AAEA;EACE,WAAA;EACA,qBAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,2BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAGA;EACE,YAAA;AAAF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AACA;EACE,eAAA;EACA,kBAAA;AAEF;AACA,o8JAAo8J","sourcesContent":[".select {\n  width: 200px;\n  margin-top: 20px;\n  margin-left: 10px;\n  padding-bottom: 5px;\n}\n\n.warn {\n  width: 200px;\n  margin-left: 10px;\n  padding-top: 0px;\n  margin-bottom: 10px;\n  font-size: 11px;\n  color: #e30526;\n}\n\n.button {\n  margin-left: 20px;\n  margin-top: 10px;\n  width: 175px;\n  text-align: center;\n}\n\n.mat-icon {\n  margin-bottom: 5px;\n}\n\n.label {\n  margin-top: 20px;\n  margin-left: 10px;\n  font-weight: bold;\n  font-size: 17px;\n}\n\n.table {\n  margin-top: 10px;\n  width: 100%;\n}\n\n.table-header {\n  font-weight: bold;\n  background-color: #f2f2ef;\n  color: #3b3b39;\n  font-size: 15pt;\n  text-align: center;\n  width: 100%;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  padding-bottom: 7px;\n  padding-top: 5px;\n}\n\n.segment {\n  font-weight: bold;\n  background-color: #7b7b7b;\n  color: #ffffff;\n  margin-top: 5px;\n  padding-left: 10px;\n  padding-bottom: 5px;\n  padding-top: 3px;\n}\n\n.region {\n  font-weight: bold;\n  margin-top: 3px;\n  padding-left: 15px;\n  border-bottom: 1px solid black;\n  padding-bottom: 4px;\n}\n\n.menu-relative {\n  display: flex;\n}\n\n.table-relative {\n  width: 100%;\n  height: 84vh;\n}\n\n.header-style {\n  font-weight: bold;\n  font-size: 15px;\n  width: 40px;\n  text-align: center;\n  padding-left: 5px !important;\n}\n\n.mat-mdc-cell {\n  width: 10px;\n  word-break: break-all;\n  border-right: 1px solid #d7d7d7;\n  padding-left: 5px !important;\n  padding-right: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 13px;\n  text-align: center;\n}\n\ntr.mat-mdc-header-row {\n  height: 20px !important;\n  padding-top: 3px !important;\n}\n\ntr.mat-mdc-row {\n  height: 28px;\n}\n\n.table-div {\n  width: 100%;\n  padding-bottom: 20px;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  //overflow: auto;\n  //height: auto;\n}\n\n.check-mark {\n  padding-left: 7px;\n}\n\n.message {\n  background-color: yellow;\n  border: 1px solid black;\n  padding: 3px;\n  margin-bottom: 9px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.cvRouter {\n  bottom: 0px;\n  position: static;\n  width: 100% !important;\n  margin: 0px;\n  padding: 0px;\n}\n\n:host ::ng-deep .p-multiselect-panel {\n  width: 200px;\n}\n:host ::ng-deep .p-select {\n  width: 200px;\n}\n:host ::ng-deep .p-datatable-header {\n  background-color: #f2f2ef;\n  font-size: 25px;\n  text-align: center;\n}\n.help-msg {\n  font-size: 12px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
